import { render, staticRenderFns } from "./HomeNormlCard.vue?vue&type=template&id=61d4e3e9&scoped=true&"
import script from "./HomeNormlCard.vue?vue&type=script&lang=js&"
export * from "./HomeNormlCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeNormlCard.vue?vue&type=style&index=0&id=61d4e3e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d4e3e9",
  null
  
)

export default component.exports